import theme from '~/theme';

export default {
  itemIcon: ({
    sidebarOpen,
    active,
    hover,
  }: {
    sidebarOpen?: boolean;
    active?: boolean;
    hover?: boolean;
  }) => ({
    display: 'flex',
    width: sidebarOpen ? '26px' : '30px',
    height: '30px',
    marginRight: sidebarOpen ? '12px' : '18px',
    marginBottom: '0px',
    color: active || hover ? 'dianomiGreen.main' : 'inherit',
    [theme.breakpoints?.down('sm')]: {
      width: '30px',
      height: '30px',
      marginRight: '0px',
      marginBottom: '0px',
    },
  }),
  hiddenIcon: {
    position: 'absolute',
    left: '20px',
    opacity: '0',
    '&:hover': {
      opacity: '1',
    },
  },
} as const;
